import ErrorBoundary from "components/ErrorBoundary";
import React, { useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import Arrow from "assets/icon/Left Chevron.svg";
import { cellRendererCheck, dateFormate } from "utils/columns";
import ReactStrapTable from "components/reactStrapTable";
import MappingHistory from "./MappingHistory";
import PurchaseHistory from "./PurchaseHistory";
import Loader from "components/Loader";

const NDCChargeCodeMapings = (props) => {
  debugger;
  const {
    Ndcflag,
    setNdcflag,
    setNdcPurchaseHistoryData,
    setNDCMapingHistoryData,
    setndcDetails,
    loading,
    orgId,
    setLoading,
    ndcDetails,
    ndcmapingHistoryData,
    ndcPurchaseHistoryData,
    crosswalkNdcsearch,
    ndcPurchaseHistoryRecords,
    setNdcPurchaseHistoryRecords,
    selectedndcpurchaseData,
    setSelectedNdcPurchaseData,
    MapingHistoryinstialValues,
    setIshiddenflag,
    ishiddenflag,
    Ndcrefetc,
    storedDate
  } = props;
  const [tableData, setTableData] = useState([]);
  const handelClickimage = () => {
    setNdcflag(false);
    Ndcrefetc(true);
  };

  let mainCol = [
    {
      dataField: "edit",
      text: "Options",
      cellRenderer: (rowData) => cellRenderEdit(rowData),
      width: 100,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: "ndc",
      text: "NDC",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.ndc),
    },
    {
      dataField: "ndcDescription",
      text: "NDC Description",
      sort: false,
      width: 200,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.ndcDescription),
    },
    {
      dataField: "ndc",
      text: "NDC",
      sort: false,
      width: 180,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.ndc),
    },

    {
      dataField: "effectivedate",
      text: "Effective Date",
      sort: true,
      width: 140,
      show: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (row) => dateFormate(row.effectivedate),
    },
    {
      dataField: "termdate",
      text: "Term Date",
      sort: false,
      width: 140,
      show: true,
      edit: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (row, col) => dateFormate(row.termdate),
    },
    {
      dataField: "bupp",
      text: "BUPP",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.bupp),
    },
    {
      dataField: "updatedby",
      text: "Modified By",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.updatedby),
    },
  ];
  let maincol1 = [];
  return (
    <div>
      <Card className="border-0 shadow-top my-3">
        <CardBody className="section-devider-border">
          <ErrorBoundary>
            <Row>
              <div className="d-flex align-items-center">
                <h4
                  className="f-16 text-primary font-weight-700"
                  style={{ cursor: "pointer" }}
                  onClick={handelClickimage}
                >
                  <span
                    style={{
                      paddingRight: "5px",
                      position: "relative",
                      top: "-1px",
                      cursor: "pointer",
                    }}
                  >
                    <img style={{ width: "9px" }} src={Arrow} />
                  </span>{" "}
                  All Order NDC{" "}
                </h4>
              </div>

              <Col md="3">
                <p className="m-0 f-14 ">NDC Code</p>
                <p className="m-0 f-14 font-weight-500 mt-1">
                  {ndcDetails?.ndc}
                </p>
              </Col>
              <Col md="3">
                <p className="m-0 f-14 ">NDC Description</p>
                <p className="m-0 f-14 font-weight-500 mt-1">
                  {ndcDetails?.drugDescription}
                </p>
              </Col>
              <Col md="2">
                <p className="m-0 f-14 ">GCN</p>
                <p className="m-0 f-14 font-weight-500 mt-1">
                  {ndcDetails?.gcnSequenceNumber}
                </p>
              </Col>

              <Col md="2">
                <p className="m-0 f-14 ">Package Size</p>
                <p className="m-0 f-14 font-weight-500 mt-1">
                  {ndcDetails?.packageSize}
                </p>
              </Col>
              <Col md="2">
                <p className="m-0 f-14 ">Last Invoiced Qty</p>
                <p className="m-0 f-14 font-weight-500 mt-1">
                  {ndcDetails?.lastInvoicedQty}
                </p>
              </Col>
            </Row>
          </ErrorBoundary>
        </CardBody>
      </Card>
      {loading && <Loader opacity={0.01} />}
      <Card className="border-0 shadow-top my-3">
        <CardBody className="section-devider-border">
          <ErrorBoundary>
            <MappingHistory
              setNDCMapingHistoryData={setNDCMapingHistoryData}
              loading={loading}
              orgId={orgId}
              setLoading={setLoading}
              ndcmapingHistoryData={ndcmapingHistoryData}
              ndcDetails={ndcDetails}
              crosswalkNdcsearch={crosswalkNdcsearch}
              ishiddenflag={ishiddenflag}
              setIshiddenflag={setIshiddenflag}
              storedDate={storedDate}
            />
          </ErrorBoundary>
        </CardBody>
      </Card>
      <Card className="border-0 shadow-top my-3">
        <CardBody className="section-devider-border">
          <ErrorBoundary>
            <PurchaseHistory
              setNdcPurchaseHistoryData={setNdcPurchaseHistoryData}
              ndcPurchaseHistoryData={ndcPurchaseHistoryData}
              loading={loading}
              setLoading={setLoading}
              ndcPurchaseHistoryRecords={ndcPurchaseHistoryRecords}
              setNdcPurchaseHistoryRecords={setNdcPurchaseHistoryRecords}
              selectedndcpurchaseData={selectedndcpurchaseData}
              setSelectedNdcPurchaseData={setSelectedNdcPurchaseData}
              MapingHistoryinstialValues={MapingHistoryinstialValues}
              orgId={orgId}

            />
          </ErrorBoundary>
        </CardBody>
      </Card>
    </div>
  );
};

export default NDCChargeCodeMapings;
